import * as React from 'react';
import styled from 'styled-components';
import { Typography } from 'components/DesignSystemV2/Typography';
import { colorsV2 } from 'style/colors-v2';
import { IconArrowChevronRightArrowRight } from 'components/Icon/SVGIcons';
import { flexGap } from 'style/css-style';

const CourseWrapper = styled.div`
  position: relative;
  width: fit-content;
  display: flex;
  align-items: center;
  ${flexGap(8)};
  cursor: pointer;
  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    background-color: ${colorsV2.blue100};
    bottom: 0;
    left: 0;
    transition: 0.5s all ease-out;
  }

  &:hover::after {
    width: 100%;
  }
`;

export const CourseTextLink = props => {
  const { text, variant = 'regular/16-24', handleAction } = props;
  return (
    <CourseWrapper onClick={handleAction}>
      <Typography variant={variant} color={colorsV2.blue100}>
        {text}
      </Typography>
      <IconArrowChevronRightArrowRight
        width={20}
        height={20}
        color={colorsV2.blue100}
      />
    </CourseWrapper>
  );
};
